import { render, staticRenderFns } from "./DaoshiMemberList.vue?vue&type=template&id=1a0a4bdf&scoped=true&"
import script from "./DaoshiMemberList.vue?vue&type=script&lang=js&"
export * from "./DaoshiMemberList.vue?vue&type=script&lang=js&"
import style0 from "./DaoshiMemberList.vue?vue&type=style&index=0&id=1a0a4bdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a4bdf",
  null
  
)

export default component.exports